export default __webpack_public_path__ + "static/media/riftbound_overnumbered.a2c8bae3.svg";